import { useEffect, useRef } from 'react'

interface UseHoneypotDetectionProps {
  currentValue: string
  setValue: (value: string) => void
}

/**
 * Custom hook for detecting bot injections in honeypot fields
 * Frequent checking every 50ms for first 5 seconds, then every 500ms
 */
export const useHoneypotDetection = ({ currentValue, setValue }: UseHoneypotDetectionProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const input = inputRef.current
    if (!input) return

    const checkValue = () => {
      const domValue = input.value
      if (domValue && domValue !== currentValue) {
        setValue(domValue)
      }
    }

    checkValue()

    let defaultInterval = setInterval(checkValue, 50)

    const slowInterval = setTimeout(() => {
      clearInterval(defaultInterval)
      defaultInterval = setInterval(checkValue, 500)
    }, 5000)

    return () => {
      clearInterval(defaultInterval)
      clearTimeout(slowInterval)
    }
  }, [currentValue, setValue])

  return inputRef
}
